var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendPaperplaneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Send Paperplane Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Send Paperplane Icon_2",
    d: "M0.261418 5.46971C-0.0865819 5.35371 -0.0899152 5.16638 0.268085 5.04704L12.9928 0.805711C13.3454 0.688378 13.5474 0.885711 13.4487 1.23104L9.81275 13.955C9.71275 14.3077 9.50942 14.3197 9.36008 13.985L6.96408 8.59304L10.9641 3.25971L5.63075 7.25971L0.261418 5.46971Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendPaperplaneIcon);
export default __webpack_public_path__ + "static/media/SendPaperplaneIcon.23e53c9ab7002dee0c3fe266c26bab35.svg";
export { ForwardRef as ReactComponent };